// extracted by mini-css-extract-plugin
module.exports = {"emptyRowContent":"ProjectsInPreparationContent_emptyRowContent__3740O"};